export default "__VITE_ASSET__D9QO2Yyt__"